// components/designer/ContextMenu.tsx
/**
 * Context Menu Component
 * 
 * Right-click menu for component manipulation:
 * - Z-index controls (bring to front, send to back, forward, backward)
 * - Duplicate component
 * - Delete component
 */

import {
    ArrowDown,
    ArrowUp,
    ChevronLeft,
    ChevronRight,
    Trash2,
} from "lucide-react";
import React from "react";

interface ContextMenuProps {
  visible: boolean;
  x: number;
  y: number;
  onClose: () => void;
  onBringToFront: () => void;
  onSendToBack: () => void;
  onBringForward: () => void;
  onSendBackward: () => void;
  onDelete: () => void;
}

const ContextMenu: React.FC<ContextMenuProps> = ({
  visible,
  x,
  y,
  onClose,
  onBringToFront,
  onSendToBack,
  onBringForward,
  onSendBackward,
  onDelete,
}) => {
  if (!visible) return null;

  return (
    <>
      <div className="fixed inset-0 z-40" onClick={onClose} />
      <div
        className="fixed bg-white border rounded-lg shadow-lg py-2 z-50 min-w-[180px]"
        style={{ left: x, top: y }}
      >
        <button
          onClick={onBringToFront}
          className="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2"
        >
          <ArrowUp size={16} />
          Bring to Front
        </button>
        <button
          onClick={onSendToBack}
          className="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2"
        >
          <ArrowDown size={16} />
          Send to Back
        </button>
        <button
          onClick={onBringForward}
          className="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2"
        >
          <ChevronRight size={16} />
          Bring Forward
        </button>
        <button
          onClick={onSendBackward}
          className="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2"
        >
          <ChevronLeft size={16} />
          Send Backward
        </button>
        <div className="border-t my-1" />
        <button
          onClick={onDelete}
          className="w-full px-4 py-2 text-left hover:bg-gray-100 text-red-600 flex items-center gap-2"
        >
          <Trash2 size={16} />
          Delete
        </button>
      </div>
    </>
  );
};

export default ContextMenu;
